<template>

<div class="scale" :class="{[clsSize]: true}">

	<div class="scale-row">

		<div class="scale-row-item"></div>
		<div class="scale-row-item" v-for="column in columns" :key="column">{{ input.text.columns[column -1 ] }}</div>

	</div>

	<div class="scale-row" v-for="variable in input.variables" :key="variable.id">

		<div class="scale-row-item is-text">{{ variable.text }}</div>
		<div class="scale-row-item" v-for="column in columns" :key="column"><div class="scale-row-item-check" v-on:click="onCheckClick(variable.id, column)" :class="{'is-active': values[variable.id] === column}" /></div>

	</div>

</div>

</template>

<script>

export default {

	props: ['input', 'flag'],

	data: function() {

		return {
		}

	},

	computed: {

		columns: function() {
			
			return this.input.text.columns.length

		},

		clsSize: function() {

			return 'size-' + this.columns.toString()

		},

		values: function() {

			var values = {}

			this.$_.each(this.input.variables, function(variable) {

				values[variable.id] = this.$store.getters['logic/variable'](variable.id)

			}.bind(this))

			return values

		}

	},

	methods: {

		onCheckClick(id, value) {

			this.$store.commit('session/values', {
				id: id, 
				value: value
			})

		}

	}

}

</script>

<style scoped>

.scale-row {
	display: grid;
	grid-template-columns: auto 80px 80px 80px 80px 80px;
}

.scale-row-item {
	height: 48px;
	font-size: 16px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.scale-row-item.is-text {
	text-align: left;
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.scale-row-item-check {
	width: 24px;
	height: 24px;
	border: 2px solid #eee;
	border-radius: 4px;
	cursor: pointer;
	line-height: 16px;
	text-align: center;
}

.scale-row-item-check:hover {
	border-color: #ccc;
}

.scale-row-item-check.is-active {
	background-color: #343434;
    border-color: #343434;
    color: #fff;
}

</style>